<template>
  <div class="wrap">
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner"></div>
    <div class="blackList">
      <!-- banner -->
      <div class="banner-box">
        <div class="banner-content">
          <h1>
            <!-- Blacklist -->
            {{ $t("blacklist.prodTitle1") }}
          </h1>
          <p>
            {{ $t("blacklist.prodContent1") }}
            <!-- Through the customer's ID number, mobile phone number, device
            number, IP, face, determine whether the customer is in the blacklist
            library, further complete customer portrait information, reduce
            business risks, reduce risks of fraud, malicious deception and other
            behaviors. -->
          </p>
        </div>
        <img src="../../assets/image/black/banner.jpg" alt="" />
      </div>
      <!-- 功能介绍 -->
      <div class="subtool-box">
        <p class="sub-title function-title">{{ $t("blacklist.prodTwoTitle1") }}</p>
        <div class="subtool-info">
          <img src="../../assets/image/black/gnjs.png" alt="" />
          <div class="subtool-content">
            <p>
              {{ $t("blacklist.prodContentSon1") }}
            </p>
          </div>
        </div>
      </div>
      <!-- 特色优势 -->
      <div class="subtool-box">
        <p class="sub-title">{{ $t("blacklist.prodThreeTitle1") }}</p>
        <ul class="special-box spe">
          <li class="spe-li">
            <div><i class="iconfont icon-saomiaoshibie380"></i></div>
            <h3>{{ $t("blacklist.prodThreeContentTitleSon1") }}</h3>
            <div class="subtool-content">
              <p>{{ $t("blacklist.prodThreeContentSon1") }}</p>
            </div>
          </li>
          <li class="spe-li">
            <div><i class="iconfont icon-jisuxiangying"></i></div>
            <h3>{{ $t("blacklist.prodThreeContentTitleSon2") }}</h3>
            <div class="subtool-content">
              <p>{{ $t("blacklist.prodThreeContentSon2") }}</p>
            </div>
          </li>
        </ul>
        <ul class="special-box actor-box">
          <li class="spe-li">
            <div><i class="iconfont icon-icon_huabanfuben"></i></div>
            <h3>{{ $t("blacklist.prodThreeContentTitleSon3") }}</h3>
            <div class="subtool-content">
              <p>
                {{ $t("blacklist.prodThreeContentSon3") }}
              </p>
            </div>
          </li>
          <li class="spe-li">
            <div><i class="iconfont icon-yonghuqunzu"></i></div>
            <h3>{{ $t("blacklist.prodThreeContentTitleSon4") }}</h3>
            <div class="subtool-content">
              <p>{{ $t("blacklist.prodThreeContentSon4") }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage: "",
      fixedHeader: false,
    };
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style scoped lang='less'>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  //大banner
  .banner-box {
    width: 100%;
    background: #181753;
    position: relative;
    top: 60px;
    .banner-content {
      width: 600px;
      position: absolute;
      top: 42%;
      left: 12%;
      transform: translate(-12%, -42%);
      color: #fff;
      h1 {
        line-height: 55px;
        font-size: 38px;
        font-weight: 500;
        letter-spacing: 4px;
        margin-bottom: 22px;
      }
      p {
        line-height: 1.6;
        letter-spacing: 2px;
        font-weight: 500;
        font-size: 16px;
      }
    }
    img {
      width: 100%;
      display: block;
    }
  }
  .actor-box {
    margin-bottom: 90px;
  }
  .subtool-box {
    width: 1200px;
    margin: 0 auto;
    // padding: 0 170px;
    box-sizing: border-box;
    text-align: center;
    // background: green;
    .exchange-box {
      margin-top: 30px !important;
    }
    .function-title {
      margin: 120px 0 30px 0 !important;
    }
    .sub-title {
      margin: 60px 0 30px 0;
      font-size: 22px;
      font-weight: bold;
    }
    .subtool-info {
      background: #fff;
      display: flex;
      box-shadow: 0px 2px 12px 0px rgba(35, 52, 58, 0.16);
      img {
        width: 280px;
      }
      .subtool-content {
        margin: auto 60px auto 16px;
        p {
          font-size: 18px;
          line-height: 30px;
          text-align: left;
          font-weight: 500;
        }
      }
    }
    .spe {
      margin-bottom: 25px;
    }
    .special-box {
      // width: 800px;
      // height: 220px;
      display: flex;
      // background: green;
      justify-content: space-between;
      li {
        width: 48%;
        background: #f2f4f6;
        text-align: left;
        padding: 30px 24px 30px 24px;
        box-sizing: border-box;
        line-height: 24px;
        // box-shadow: 0px 2px 12px 0px rgba(35, 52, 58, 0.16);
        border-radius: 16px;
        i {
          font-size: 34px;
        }
        h3 {
          margin: 20px 0;
          font-size: 24px;
        }
        .subtool-content {
          p {
            // font-size: 14px;
            line-height: 24px;
          }
        }
      }
      .spe-li:hover {
        background: #1097f0;
        color: #fff;
      }
    }
    //支持与交流
    // .support-box {
    //   li {
    //     position: relative;
    //     height: 200px;
    //     .support-detail {
    //       width: 100%;
    //       height: 40px;
    //       line-height: 40px;
    //       padding-left: 24px;
    //       box-sizing: border-box;
    //       background: #181753;
    //       color: #fff;
    //       font-size: 16px;
    //       position: absolute;
    //       left: 0;
    //       bottom: 0;
    //     }
    //   }
    // }
    //更多
    .more-box {
      height: 400px;
      // background: pink;
      li {
        img {
          width: 109%;
          height: 200px;
          margin-top: -30px;
          margin-left: -24px;
        }
      }
    }
    // 产品试用
    // .database:hover /deep/.avatar-uploader .el-upload{
    //   border-color: #409eff;
    // }
    .database {
      width: 100%;
      padding: 8px 0px;
      .upload-btn {
        width: 100%;
        height: 246px;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        position: absolute;
        z-index: 999;
      }
      .upload-dis {
        width: 100%;
        height: 300px;
        opacity: 0;
        position: absolute;
        z-index: 0;
      }
      .upload-btn:hover {
        cursor: pointer;
      }
      .inp {
        .form-box {
          display: flex;
          justify-content: space-between;
          width: 100%;
          flex-wrap: wrap;
          .el-form-item {
            width: 49%;
          }
        }
      }

      .button {
        width: 100%;
        height: 36px;
        margin: 0px auto 45px;
        // margin-bottom: 30px;
        text-align: center;
        .el-button {
          width: 66px;
          text-align: center;
          margin-left: 94%;
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
      }
    }
    .result {
      // width: 95%;
      padding-bottom: 16px;
      .box {
        min-height: 80px;
      }
      .result-wrap {
        margin: 30px auto;
        box-shadow: 0px 2px 20px 0px rgba(35, 52, 58, 0.16);
        display: flex;
        flex-wrap: wrap;
        padding: 25px 0px 0px 20px;
        box-sizing: border-box;
        // margin-top: 15px;
        // flex-wrap: wrap;
        li {
          //   width: 200px;
          //height: 50px;
          line-height: 1.6;
          margin-bottom: 25px;
          margin-right: 14px;
          p {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
